export class OrderErrorCodes {
  // Language parameter missing or invalid. Must be either of those: %s.
  public static ORDER_LANGUAGE_MISSING = 1000;

  // No valid JSON object was provided. Order cancelled.
  public static ORDER_JSON_INVALID = 1001;

  // This order is invalidated.
  public static ORDER_INVALIDATED = 1002;

  // This order is already submitted and can not be modified.
  public static ORDER_SUBMITTED = 1003;

  // Some products could not be found. Please provide product ids of existing products.
  public static ORDER_PRODUCT_NOT_FOUND = 1004;

  // Some slots could not be found. Please provide slot ids of existing slots.
  public static ORDER_SLOT_NOT_FOUND = 1005;

  // Slot for selected product is out of range of the related events period.
  public static ORDER_SLOT_OUT_OF_RANGE = 1006;

  // No matching VatRate for product with ID %s for given start with %s found
  public static ORDER_VATRATE_NOT_FOUND = 1007;

  // Was not able to create new order with number data %s.
  public static ORDER_INSERT_ERROR = 1008;

  // No Slot submitted.
  public static ORDER_SLOT_NOT_SET = 1009;

  // Slot does not exist for given product.
  public static ORDER_SLOT_FOR_PRODUCT_DOES_NOT_EXIST = 1010;

  // You cannot claim more than one personal use per product.
  public static ORDER_CLAIM = 1011;

  // There are no order items available.
  public static ORDER_ITEMS_EMPTY = 1012;

  // Failed to add order items due to slot limitations.
  public static ORDER_ITEM_LIMITATION = 1013;

  // Order not found.
  public static ORDER_NOT_FOUND = 1014;

  // This order is expired.
  public static ORDER_EXPIRED = 1015;

  // Please accept the required terms and conditions and privacy statements.
  public static ORDER_AGB_PRIVACY_CHECK_FAILED = 1016;

  // Promotioncode ' . $code . ' is currently not available (status 1).
  public static PROMOTIONCODE_NOT_AVAILABLE = 1017;

  // Promotioncode ' . $code . ' is expired.
  public static PROMOTIONCODE_EXPIRED = 1018;

  // 'Advertisingcode ' . $code . ' is currently not available (status 1).'
  public static ADVERTISINGOCODE_NOT_AVAILABLE = 1019;

  // 'No matching product for given advertsingcode ' . $code . ' in cart.'
  public static ADVERTISINGCODE_PRODUCT_NOT_FOUND = 1020;

  // 'Advertisingcode ' . $code . ' is expired.'
  public static ADVERTISINGCODE_EXPIRED = 1021;

  // No matching Tickets were found.
  public static REDEEM_NO_TICKETS_FOUND = 1022;

  // Some tickets could not be found or were already registered.
  public static REDEEM_SOME_TICKETS_NOT_FOUND = 1023;

  // You may not use more than one registration code for a single product.
  public static REDEEM_USED_MORE_THAN_ONE_REGISTRATIONCODE = 1024;

  // No matching Order was found for some of the given tickets.
  public static REDEEM_NO_MATCHING_ORDER_FOUND = 1025;

  // Some codes don\'t exist or have already been used.
  public static CODES_USED_OR_DOES_NOT_EXIST = 1026;

  // Invalid parameter format for "codes
  public static CODES_INVALID_FORMAT = 1027;

  // '"codes" parameter missing.'
  public static CODES_PARAMETER_MISSING = 1028;

  // shop only allows id=1, sms only id=2
  public static ORDER_PRODUCT_WRONG_DISTRIB_CHANNEL = 1029;

  // the two defined date ranges (publication, bookingPos) are exceeded in some way
  public static ORDER_PRODUCT_NOT_PURCHASABLE = 1055;

  // the defined mins/maxs of the product are exceeded in some way
  public static ORDER_PRODUCT_QUANTITY_INVALID = 1056;

  // You cannot claim personal use on a sub product
  public static ORDER_CLAIM_PERSONAL_USE_ON_SUB_PRODUCT = 1057;

  // Something went wrong processing payment info related stuff
  public static ORDER_PAYMENT_INFO_INVALID = 1058;

  // Something went wrong processing payment customer related stuff
  public static ORDER_PAYMENT_CUSTOMER_INFO_INVALID = 1059;

  // the event of the claimed registration code is already over
  public static CODES_EVENT_EXPIRED = 1069;

  // the order of this code has an invalid status (cancelled, anonymized, ...)
  public static CODES_ORDER_INVALID = 1070;

  // Promo code had no effect, e.g. all products already have a promo and customer adds cart promo
  public static PROMOTIONCODE_NO_EFFECT = 1071;

  public static ORDER_ADDITIONAL_PRODUCT_NOT_PURCHASABLE = 1079;

  public static isValidErrorCode(code: number): boolean {
    return Object.values(OrderErrorCodes).find(c => c === code) !== undefined;
  }
}
